module.exports = __webpack_public_path__ + "components/weather-icon/static/nightheavyrain-fb6228f684b14a163bb096fbbed06791.svg";